import InboundLocation from "./InBound";
import OutboundLocation from "./OutBound";

const locations = { InboundLocation, OutboundLocation };

export default locations;
